module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Giro Pending ")]), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Tgl. Terima Giro")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "daterange",
      "placeholder": "Select date"
    },
    on: {
      "on-change": function($event) {
        return _vm.getReceivableGiroList()
      }
    },
    model: {
      value: (_vm.giroDateSelected),
      callback: function($$v) {
        _vm.giroDateSelected = $$v
      },
      expression: "giroDateSelected"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Tgl. Jatuh Tempo")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "daterange",
      "placeholder": "Select date"
    },
    on: {
      "on-change": function($event) {
        return _vm.getReceivableGiroList()
      }
    },
    model: {
      value: (_vm.paymentDateSelected),
      callback: function($$v) {
        _vm.paymentDateSelected = $$v
      },
      expression: "paymentDateSelected"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "custom-group-switch"
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.isGroupFilter),
      callback: function($$v) {
        _vm.isGroupFilter = $$v
      },
      expression: "isGroupFilter"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-right"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == false),
      expression: "isGroupFilter == false"
    }],
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Select Marking",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingGetMarking
    },
    on: {
      "on-change": function($event) {
        return _vm.getReceivableGiroList()
      }
    },
    model: {
      value: (_vm.markingHeaderIdSelected),
      callback: function($$v) {
        _vm.markingHeaderIdSelected = $$v
      },
      expression: "markingHeaderIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-left"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == true),
      expression: "isGroupFilter == true"
    }],
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Select Group Name",
      "remote-method": _vm.getGroupMarkingByCode,
      "loading": _vm.isLoadingGetMarking
    },
    on: {
      "on-change": function($event) {
        return _vm.getReceivableGiroList()
      }
    },
    model: {
      value: (_vm.markingGroupIdSelected),
      callback: function($$v) {
        _vm.markingGroupIdSelected = $$v
      },
      expression: "markingGroupIdSelected"
    }
  }, _vm._l((_vm.optionGroupMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingGiroList),
      expression: "isLoadingGiroList"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', [_c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalGiro != 0),
      expression: "totalGiro != 0"
    }],
    attrs: {
      "type": "info",
      "show-icon": ""
    }
  }, [_vm._v(" Total Giro = " + _vm._s(_vm.totalGiro) + " lembar")]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalGiro != 0),
      expression: "totalGiro != 0"
    }],
    attrs: {
      "type": "success",
      "show-icon": ""
    }
  }, [_vm._v(" Total Nominal = Rp " + _vm._s(_vm._f("numberFormatted")(_vm.totalNominal)))]), _vm._v(" "), _c('Table', {
    attrs: {
      "row-class-name": _vm.rowClassName,
      "columns": _vm.columnsDataTable,
      "data": _vm.receivableGiroData
    }
  })], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Konfirmasi",
      "ok-text": "Ya",
      "cancel-text": "Tidak"
    },
    on: {
      "on-ok": _vm.updateGiroList,
      "on-cancel": _vm.cancelUpdateGiroList
    },
    model: {
      value: (_vm.isModalConfirm),
      callback: function($$v) {
        _vm.isModalConfirm = $$v
      },
      expression: "isModalConfirm"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.confirmationMessage))])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "History"
    },
    model: {
      value: (_vm.isModalHistory),
      callback: function($$v) {
        _vm.isModalHistory = $$v
      },
      expression: "isModalHistory"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columnsHistory,
      "data": _vm.dataHistory
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddd7d926","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/giro/GiroPending.vue
// module id = 1856
// module chunks = 1